import { Navigate } from 'react-router-dom'
import useAuth from '../hooks/useAuth'
import useFeatureAccess from '../hooks/useFeatureAccess'

/**
 * Wraps a route — redirects to /dashboard if the user lacks access to the feature.
 * For admin_panel, does a direct role check (never trust feature flags alone).
 */
export default function FeatureRoute({ flag, children }) {
  const { can, loaded, role } = useFeatureAccess()
  const profile = useAuth((s) => s.profile)

  // For admin_panel: direct role check, don't wait for flags
  if (flag === 'admin_panel') {
    const userRole = profile?.role || role
    if (userRole !== 'admin') return <Navigate to="/dashboard" replace />
    return children
  }

  // While flags are loading, render children (avoid flash redirect)
  if (!loaded) return children

  if (flag && !can(flag)) return <Navigate to="/dashboard" replace />
  return children
}
